import React from 'react';
import { Card, CardHeader, CardSection } from '../../../components/ui/Card';

function VideosList({ state }) {
  return (
    <Card>
      <CardHeader title="Meus vídeos" subtitle={state.videoProgress || 'Histórico de geração de vídeos'} />
      <CardSection>
        {state.loadingVideos && <p className="videos-page__placeholder">Carregando vídeos...</p>}

        {!state.loadingVideos && state.myVideos.length === 0 && (
          <p className="videos-page__placeholder">Nenhum vídeo encontrado.</p>
        )}

        <div className="videos-page__list">
          {state.myVideos.map((video) => (
            <article key={video.id} className="videos-page__item">
              <div>
                <h4>{video.title || 'Vídeo gerado'}</h4>
                <p>{video.created_at ? new Date(video.created_at).toLocaleString('pt-BR') : ''}</p>
              </div>
              {video.url && (
                <a className="videos-page__link" href={video.url} target="_blank" rel="noreferrer">
                  Abrir
                </a>
              )}
            </article>
          ))}
        </div>
      </CardSection>
    </Card>
  );
}

export default VideosList;
